//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import searchUtils from '~/mixins/search/search-utils'

export default {
  name: 'SearchMobileBar',
  mixins: [searchUtils],
  computed: {
    getParentLocations () {
      let title = (this.location.location)[this.location.type] || 'Tubber'
      if (this.locationsFull && this.locationsFull.length) {
        title = ''
        this.locationsFull.forEach((location, i) => {
          title += (i > 0 ? ', ' : '') + (location.location)[location.type]
        })
      }
      return title
    }
  }
}
